const randomize = require("randomatic");

export default [
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/label-boxes/Agent"),
    name: "Agent",
    visible: true,
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/label-boxes/Basic"),
    name: "Reference",
    visible: true,
    props: {
      label: "REFERENCE",
      value: "reference",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/label-boxes/Basic"),
    name: "Department",
    visible: false,
    props: {
      label: "DEPARTMENT",
      value: "department",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/label-boxes/Basic"),
    name: "Booking Status",
    visible: true,
    props: {
      label: "BOOKING STATUS",
      value: "bookingStatus",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/label-boxes/Basic"),
    name: "Internal Status",
    visible: false,
    props: {
      label: "INTERNAL STATUS",
      value: "internalStatus",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/label-boxes/Basic"),
    name: "Booked By",
    visible: false,
    props: {
      label: "BOOKED BY",
      value: "bookedByName",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/label-boxes/Basic"),
    name: "Internal Ref",
    visible: false,
    props: {
      label: "INTERNAL REF",
      value: "internalReference",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/label-boxes/Basic"),
    name: "Client Ref",
    visible: false,
    props: {
      label: "CLIENT REF",
      value: "clientReference",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/label-boxes/Basic"),
    name: "Client",
    visible: false,
    props: {
      label: "CLIENT",
      value: "clientName",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/label-boxes/Basic"),
    name: "Passengers",
    visible: false,
    props: {
      label: "PASSENGERS",
      labeler: (it) => it.participants.edges.length,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/label-boxes/Basic"),
    name: "Pax",
    visible: false,
    props: {
      label: "ADULTS/CHILDREN/INFANTS",
      labeler: (it) => `${it.pax.adults}/${it.pax.children}/${it.pax.infants}`,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/label-boxes/Basic"),
    name: "Created by",
    visible: false,
    props: {
      label: "CREATED BY",
      labeler: (it) => it.createdBy.name,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/label-boxes/Basic"),
    name: "Created Date",
    visible: false,
    props: {
      label: "CREATED DATE",
      value: "createdAt",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/label-boxes/Basic"),
    name: "Start Date",
    visible: false,
    props: {
      label: "START DATE",
      value: "startDate",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/label-boxes/Basic"),
    name: "End Date",
    visible: false,
    props: {
      label: "END DATE",
      value: "endDate",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/label-boxes/Basic"),
    name: "Brand",
    visible: false,
    props: {
      label: "BRAND",
      value: "brand",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/label-boxes/Basic"),
    name: "Destination",
    visible: false,
    props: {
      label: "DESTINATION",
      value: "destinationName",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/label-boxes/Basic"),
    name: "Total Price",
    visible: false,
    props: {
      label: "TOTAL PRICE",
      labeler: (it) =>
        `${Number(Number(it.totalPrice).toFixed(2)).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })} ${it.currencyCode}`,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/label-boxes/Basic"),
    name: "Per Person Price",
    visible: false,
    props: {
      label: "PER PERSON PRICE",
      labeler: (it) =>
        `${Number(
          Number(
            Number(it.totalPrice) /
              (Number(it.pax.adults) + Number(it.pax.children))
          ).toFixed(2)
        ).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })} ${it.currencyCode}`,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/label-boxes/Basic"),
    name: "Agent Commission",
    visible: false,
    props: {
      label: "AGENT COMMISSION",
      labeler: (it) =>
        `${Number(Number(it.commission).toFixed(2)).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })} ${it.currencyCode}`,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/label-boxes/Basic"),
    name: "Supplier Commission Total",
    visible: false,
    props: {
      label: "SUPPLIER COMMISSION TOTAL",
      labeler: (it) =>
        it.profit
          ? `${Number(
              Number(it.profit.supplierCommission).toFixed(2)
            ).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })} ${it.currencyCode}`
          : "-",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/label-boxes/Basic"),
    name: "Supplier Commission Received",
    visible: false,
    props: {
      label: "SUPPLIER COMMISSION RECEIVED",
      labeler: (it) =>
        it.profit
          ? `${Number(
              Number(it.profit.supplierCommissionReceived).toFixed(2)
            ).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })} ${it.currencyCode}`
          : "-",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/label-boxes/Basic"),
    name: "Supplier Commission Balance",
    visible: false,
    props: {
      label: "SUPPLIER COMMISSION BALANCE",
      labeler: (it) =>
        it.profit
          ? `${Number(
              Number(it.profit.supplierCommissionBalance).toFixed(2)
            ).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })} ${it.currencyCode}`
          : "-",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/label-boxes/Basic"),
    name: "Agent Commission Adjustment",
    visible: false,
    props: {
      label: "AGENT COMMISSION ADJUSTMENT",
      labeler: (it) =>
        `${Number(Number(it.commissionAdjustment).toFixed(2)).toLocaleString(
          undefined,
          {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }
        )} ${it.currencyCode}`,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/label-boxes/Basic"),
    name: "Agent Net Commission",
    visible: false,
    props: {
      label: "AGENT NET COMMISSION",
      labeler: (it) =>
        `${Number(Number(it.netCommission).toFixed(2)).toLocaleString(
          undefined,
          {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }
        )} ${it.currencyCode}`,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/label-boxes/Basic"),
    name: "Net Margin %",
    visible: false,
    props: {
      label: "NET MARGIN %",
      labeler: (it) =>
        it.profit
          ? `${Number(Number(it.profit.margin).toFixed(2)).toLocaleString(
              undefined,
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }
            )}%`
          : "-",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/label-boxes/Basic"),
    name: "Net Markup %",
    visible: false,
    props: {
      label: "NET MARKUP %",
      labeler: (it) =>
        it.profit
          ? `${Number(Number(it.profit.markup).toFixed(2)).toLocaleString(
              undefined,
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }
            )}%`
          : "-",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/label-boxes/Basic"),
    name: "Net Profit",
    visible: false,
    props: {
      label: "NET PROFIT",
      labeler: (it) =>
        it.profit
          ? `${Number(Number(it.profit.netProfit).toFixed(2)).toLocaleString(
              undefined,
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }
            )} ${it.currencyCode}`
          : "-",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/label-boxes/Basic"),
    name: "Gross Profit",
    visible: false,
    props: {
      label: "GROSS PROFIT",
      labeler: (it) =>
        it.profit
          ? `${Number(Number(it.profit.grossProfit).toFixed(2)).toLocaleString(
              undefined,
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }
            )} ${it.currencyCode}`
          : "-",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/label-boxes/Basic"),
    name: "Paid",
    visible: false,
    props: {
      label: "PAID",
      labeler: (it) =>
        `${Number(Number(it.paid).toFixed(2)).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })} ${it.currencyCode}`,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/label-boxes/Basic"),
    name: "Balance",
    visible: false,
    props: {
      label: "BALANCE",
      labeler: (it) =>
        `${Number(Number(it.balance).toFixed(2)).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })} ${it.currencyCode}`,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/label-boxes/Basic"),
    name: "Gross Balance",
    visible: false,
    props: {
      label: "Gross BALANCE",
      labeler: (it) =>
        `${Number(Number(it.grossBalance).toFixed(2)).toLocaleString(
          undefined,
          {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }
        )} ${it.currencyCode}`,
    },
  },
];



// WEBPACK FOOTER //
// ./src/components/gt/itineraries/details-boxes-list.js